import { FC } from 'react';
import { useFragment } from 'react-relay';
import graphql from 'babel-plugin-relay/macro';

import Stack from '@mui/material/Stack';
import Section from 'components/Section';
import TranslatableTextField from 'components/TranslatableTextField';
import TextField from 'components/TextField';
import RoomPropertySelect from 'components/RoomPropertySelect';

import { RoomEditMainGeneral_data$key } from '__generated__/RoomEditMainGeneral_data.graphql';
import { RoomEditMainGeneral_room$key } from '__generated__/RoomEditMainGeneral_room.graphql';

type Props = {
  data: RoomEditMainGeneral_data$key;
  room: RoomEditMainGeneral_room$key;
};

const RoomEditMainGeneral: FC<Props> = props => {
  const { name } = useFragment(
    graphql`
      fragment RoomEditMainGeneral_room on Room {
        name {
          ...TranslatableTextField_text
        }
      }
    `,
    props.room
  );

  const data = useFragment(
    graphql`
      fragment RoomEditMainGeneral_data on Query {
        ...RoomPropertySelect_data
        ...TranslatableTextField_data
      }
    `,
    props.data
  );

  return (
    <Section id="general" title="Bendra informacija">
      <Stack spacing={4}>
        <TranslatableTextField
          name="name"
          label="Pavadinimas"
          text={name}
          data={data}
        />

        <TextField fullWidth name="capacity" label="Vietų skaičius" />

        <RoomPropertySelect name="properties" label="Savybės" data={data} />
      </Stack>
    </Section>
  );
};

export default RoomEditMainGeneral;
